export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'created_at',
    caption: 'Criação',
    dataType: 'date',
    format: 'dd/MM/yyyy HH:mm',
    width: 150
  },
  {
    dataField: 'nome',
    caption: 'Nome'
  },
  {
    dataField: 'email',
    caption: 'Email'
  },
  {
    caption: 'Ações',
    cellTemplate: 'acaoCell',
    width: 100
  }
]
